export default __webpack_public_path__ + "static/media/Mask Group 5.0938d648.png";